import { ScheduleLinesTable } from '../components/purchasing/tabs/schedule-lines';

export default function POLineSchedules() {
  return <ScheduleLinesTable />;
}
